import SBIcon, { IconColors, IconTypes } from '@sendbird/uikit-react/ui/Icon';
import SBIconButton from '@sendbird/uikit-react/ui/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';
import { selectCompanyNamesMap } from '_store/orders/selector';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

import { parseChannelData } from '../../../helpers';

const StyledGroupChannelHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.small2X}px;
  padding-top: ${theme.spaces.regular}px;
  padding-bottom: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
  padding-left: ${theme.spaces.smallX}px;
  border-bottom: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
`;

const StyledGroupChannelHeaderIconContainer = styled.div`
  padding: ${theme.spaces.smallX}px;
`;

const StyledGroupChannelHeaderContent = styled.div`
  flex-grow: 1;
`;

const StyledGroupChannelHeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
`;

const CustomGroupChannelHeader = ({ currentChannel, showSearchIcon, onSearchClick }) => {
  const companyNamesMap = useSelector(selectCompanyNamesMap);
  const { productId } = parseChannelData(currentChannel?.data);

  const isMuted = currentChannel?.myMutedState === 'muted';

  return (
    <StyledGroupChannelHeader>
      <StyledGroupChannelHeaderIconContainer>
        <Icon alias={ICON_ALIASES.message} color={theme.colors.indigo.primary} />
      </StyledGroupChannelHeaderIconContainer>
      <StyledGroupChannelHeaderContent>
        <Text desktop size={theme.fontSizes.regular} weight={600} color={theme.colors.gray.primary}>
          {companyNamesMap[productId]}
        </Text>
        <Text mobile size={theme.fontSizes.small} weight={600} color={theme.colors.gray.primary}>
          {companyNamesMap[productId]}
        </Text>
        <Text desktop size={theme.fontSizes.small} weight={400} color={theme.colors.gray.secondary}>
          {currentChannel?.name}
        </Text>
        <Text mobile size={theme.fontSizes.smallX} weight={400} color={theme.colors.gray.secondary}>
          {currentChannel?.name}
        </Text>
      </StyledGroupChannelHeaderContent>
      <StyledGroupChannelHeaderActions>
        {isMuted && (
          <SBIcon
            className="sendbird-chat-header__right__mute"
            type={IconTypes.NOTIFICATIONS_OFF_FILLED}
            fillColor={IconColors.ON_BACKGROUND_2}
            width="24px"
            height="24px"
          />
        )}
        {showSearchIcon && !currentChannel?.isEphemeral && (
          <SBIconButton
            className="sendbird-chat-header__right__search"
            width="32px"
            height="32px"
            onClick={onSearchClick}
          >
            <SBIcon type={IconTypes.SEARCH} fillColor={IconColors.PRIMARY} width="24px" height="24px" />
          </SBIconButton>
        )}
      </StyledGroupChannelHeaderActions>
    </StyledGroupChannelHeader>
  );
};

CustomGroupChannelHeader.propTypes = {
  currentChannel: PropTypes.object,
  showSearchIcon: PropTypes.bool,
  onSearchClick: PropTypes.func,
};

export default CustomGroupChannelHeader;
